module.exports = __webpack_public_path__ + "static/Q2Answer3_TheDark_RosieFraser-8dd56544356c5a90b579d122300a6ee5.jpg";